import React, {ReactNode} from 'react';
import cx from 'classnames';
import {Scrollbar} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../Localization';
import styles from './styles.module.scss';

export const Content = (props: {children?: ReactNode; componentClasses?: string}) => {
    return (
        <div className={cx(styles.content, props.componentClasses)}>
            <Scrollbar componentClasses={styles.scroll} rtl={isRTL()}>
                <ContentInner>{props.children}</ContentInner>
            </Scrollbar>
        </div>
    );
};

export const ContentInner = (props: {children?: ReactNode}) => {
    return <div className={styles.contentInner}>{props.children}</div>;
};
